export default __webpack_public_path__ + "static/media/face02.6dfbb44d.png";